import React from "react"

export const files = () => ({
  commands: {
    insertFile: (editor, { url, name, ...attributes }) => {
      if (editor.value.selection.isCollapsed) {
        const startOffset = editor.value.selection.start.offset
        const endOffset = startOffset + name.length

        editor.insertText(name).moveAnchorTo(startOffset).moveFocusTo(endOffset)
      } else if (editor.isFile(editor.value)) {
        editor.unwrapFile()
      }

      editor.wrapFile({ url, name, ...attributes })
      editor.moveToEnd()
    },
    wrapFile: (editor, { url, name, ...attributes }) => {
      editor.wrapInline({
        type: "file",
        data: { url, ...attributes }
      })
    },
    unwrapFile: editor => {
      editor.unwrapInline("file")
    }
  },
  queries: {
    isFile(editor) {
      return editor.value.inlines.some(inline => inline.type === "file")
    }
  },
  renderNode(props, editor, next) {
    const { children, node, attributes } = props
    switch (node.type) {
      case "file":
        return (
          <a
            href={node.data.get("url")}
            {...attributes}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        )

      default:
        return next()
    }
  }
})
